//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { crl8 } from 'app/curalate.globals';
import universalImageActionsOnePageTemplate from '@legacy-components/common/universal-image-actions/universal-image-actions-one-page.html';

(() => {
  const uia = angular.module('uia');

  uia.directive('universalImageActionsOnePage', [() => {
    return {
      restrict: 'E',
      scope: {},
      require: '^universalImageActionsModal',
      template: universalImageActionsOnePageTemplate,
      controller: [
        '$scope',
        'UniversalImageActionsService',
        (
          $scope,
          UniversalImageActionsService,
        ) => {
          const launchOptions = UniversalImageActionsService.getCurrentLaunchOptions();
          const itemId = launchOptions.getUniversalItemId();
          const clientId = crl8.session.client.id;

          $scope.model = {
            cuid: `${itemId}.${clientId}`,
          };

          $scope.model.close = () => {
            $scope.$emit('uia:modal:close');
          };
        },
      ],
    };
  }]);
})();
